import DocumentCategoryService from "../../../services/v2/bytepro/documentCategory.service";

export const documentCategoryApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getDocumentCategories({ commit }) {
      return DocumentCategoryService.getDocumentCategories().then(
        (resp) => {
          commit(
            "dummyConsole",
            "DocumentCategoryService.getDocumentCategories - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "DocumentCategoryService.getDocumentCategories - error"
          );
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
